import * as React from 'react';
import { SVGProps } from 'react';

const IconCameraSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 9V4a1 1 0 0 1 1-1h2l.324-.648S4.5 2 5 2h2c.5 0 .676.352.676.352L8 3h2a1 1 0 0 1 1 1v5c0 .5-.448 1-1 1H2c-.678 0-1-.322-1-1zm6.5-4c-.75-.9-2.25-.9-3 0-.625.75-.625 1.75 0 2.5.75.9 2.25.9 3 0 .625-.75.625-1.75 0-2.5z"
    />
  </svg>
);
export default IconCameraSizeXs;
